import { SyncStatusEnum } from 'src/graphql/schema';

export const syncStatusOptions = [
  {
    label: 'Connected',
    value: SyncStatusEnum.Active,
  },
  {
    label: 'Pending',
    value: SyncStatusEnum.Pending,
  },
  {
    label: 'Disconnected',
    value: SyncStatusEnum.Disconnected,
  },
];

export const syncStatusMap = {
  [SyncStatusEnum.Active]: {
    label: 'Connected',
    textColor: 'text-green-700',
    dotColor: 'bg-green-500',
  },
  [SyncStatusEnum.AwaitingSync]: {
    label: 'Pending',
    textColor: 'text-gray-500',
    dotColor: 'bg-gray-400',
  },
  [SyncStatusEnum.Pending]: {
    label: 'Pending',
    textColor: 'text-gray-500',
    dotColor: 'bg-gray-400',
  },
  [SyncStatusEnum.Disconnected]: {
    label: 'Disconnected',
    textColor: 'text-rose-700',
    dotColor: 'bg-rose-500',
  },
  [SyncStatusEnum.GracePeriod]: null,
  [SyncStatusEnum.Deleted]: null,
} as const;
